"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tpfFundManagerConfig = void 0;
const env_1 = require("../env/env");
exports.tpfFundManagerConfig = {
    TPF_FUND_MANAGER_BASE_URL: env_1.env.getString('TPF_FUND_MANAGER_BASE_URL') || 'http://localhost:4242',
};
//# sourceMappingURL=tpfFundManagerConfig.js.map